/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AccountDeletionDtoFromJSON, AccountDeletionDtoToJSON, } from './AccountDeletionDto';
import { OnboardingStatusFromJSON, OnboardingStatusToJSON, } from './OnboardingStatus';
import { UserPreferencesDtoFromJSON, UserPreferencesDtoToJSON, } from './UserPreferencesDto';
import { UserProfileDtoFromJSON, UserProfileDtoToJSON, } from './UserProfileDto';
import { UserWalletDtoFromJSON, UserWalletDtoToJSON, } from './UserWalletDto';
/**
 * Check if a given object implements the MeResponse interface.
 */
export function instanceOfMeResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function MeResponseFromJSON(json) {
    return MeResponseFromJSONTyped(json, false);
}
export function MeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !exists(json, 'status') ? undefined : OnboardingStatusFromJSON(json['status']),
        'userProfile': !exists(json, 'userProfile') ? undefined : UserProfileDtoFromJSON(json['userProfile']),
        'userPreferences': !exists(json, 'userPreferences') ? undefined : UserPreferencesDtoFromJSON(json['userPreferences']),
        'userWallet': !exists(json, 'userWallet') ? undefined : UserWalletDtoFromJSON(json['userWallet']),
        'accountDeletion': !exists(json, 'accountDeletion') ? undefined : AccountDeletionDtoFromJSON(json['accountDeletion']),
    };
}
export function MeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': OnboardingStatusToJSON(value.status),
        'userProfile': UserProfileDtoToJSON(value.userProfile),
        'userPreferences': UserPreferencesDtoToJSON(value.userPreferences),
        'userWallet': UserWalletDtoToJSON(value.userWallet),
        'accountDeletion': AccountDeletionDtoToJSON(value.accountDeletion),
    };
}
